module.exports = __webpack_public_path__ + "media/img/event/academy-profiling-footer-192bea4d0b93e024ae584aba7cb9bfe8.jpeg";